/* NeckRelax : dates de livraison estimees (4 a 8 jours calendaires, week-ends compris, heure de Paris) */
(function () {
  if (window.__nrDelivery) return;
  window.__nrDelivery = true;
  var D = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var M = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var MIN = 4, MAX = 8;
  function text() {
    var o = {};
    try {
      new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date())
        .forEach(function (p) { o[p.type] = p.value; });
    } catch (e) {
      var n = new Date();
      o = { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate() };
    }
    var base = Date.UTC(+o.year, +o.month - 1, +o.day);
    var a = new Date(base + MIN * 864e5), z = new Date(base + MAX * 864e5);
    function label(x, withMonth) {
      var d = x.getUTCDate();
      return D[x.getUTCDay()] + ' ' + (d === 1 ? '1er' : d) + (withMonth ? ' ' + M[x.getUTCMonth()] : '');
    }
    return 'entre le ' + label(a, a.getUTCMonth() !== z.getUTCMonth()) + ' et le ' + label(z, true);
  }
  function fill() {
    var t = text();
    document.querySelectorAll('[data-nr-delivery-dates]').forEach(function (el) {
      if (el.textContent !== t) el.textContent = t;
    });
  }
  fill();
  new MutationObserver(fill).observe(document.documentElement, { childList: true, subtree: true });
})();
